import React from "react";
import { withIcon, errorBorder, iconElement, inputElement, inputLabel, inputWrapper, errorTextElement } from "./input.module.css";

/**
 * type is for the input type itself
 * inputType is to choose between "textarea" or 'input'
 * error is the error state of the textField
 * icon should take icons in a html elements
 * errorText holds the error message if you want to show one
 *
 */
const Input = ({
  className,
  label,
  icon,
  error,
  errorText,
  ...restProps
}) => {


  return (
    <div className={`${inputWrapper}`}>
      <label className={`className ${inputLabel}`}> {label}</label>
      {icon === "" ?
        <div>
          <input
                // className={ `className ${inputElement} { error && ${errorBorder} } `}
                className={ `className ${error ? errorBorder :  inputElement} }`}
          {...restProps}
          />
          <p className={errorTextElement}>{errorText}</p>
        </div>
        :
        <div className={withIcon} >
          <input
            // className={ `className ${inputElement} { error && ${errorBorder} } `}
            className={ `className ${error ? errorBorder :  inputElement} }`}


            {...restProps}
          />
          <span className={iconElement} 
          >{icon}</span>
          <p className={errorTextElement} >{errorText}</p>
        </div>
      }

    </div>
  );
};

export { Input }